import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import React, { useState } from "react";
import SearchFilterComp from "src/components/shared/SearchFilterComp";
import useInventoryBatchList from "src/hooks/inventory/useInventoryBatchList";
import useManualCreateBulkReturnProcessing from "src/hooks/orders/bulk-return-processing/useManualCreateBulkReturnProcessing";
import { customerList, productList, productModelList, saleList } from "src/utils/productState";

export default function ManualBulkReturnByProductForm({ returnedFormId, warehouseId }) {
  const [manualProductForm, setManualProductForm] = useState();
  const [clearForm, setClearForm] = useState(false);

  const { trigger: manualCreate } = useManualCreateBulkReturnProcessing(returnedFormId);
  const { data: batch } = useInventoryBatchList({ product: manualProductForm?.product, productModel: manualProductForm?.productModel, warehouse: warehouseId });

  const handleFillReturnForm = (name, value) => {
    setManualProductForm({ ...manualProductForm, [name]: value });
  };

  const onAddProduct = async () => {
    const res = await manualCreate({
      body: {
        customer: manualProductForm?.customer,
        productModel: manualProductForm?.productModel,
        batch: manualProductForm?.batch,
        qty: manualProductForm?.qty,
      },
    });

    if (res?.success) {
      setManualProductForm(undefined);
      setClearForm((prev) => !prev);
      return enqueueSnackbar("Thành công!", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message, { variant: "error" });
    }
  };

  return (
    <Box
      display="flex"
      gap={1.5}
      flexDirection="column"
      p={1.5}
    >
      <SearchFilterComp
        clear={clearForm}
        minWidth={0}
        width="100%"
        selectList={saleList}
        size="default"
        autoComplete={{
          sale: {
            label: "Nhân viên kinh doanh",
            limit: 20,
            skip: 0,
            type: "Sales",
            endpoint: `/api/v1/users`,
            state: (e) => handleFillReturnForm("sales", e),
          },
          sx: { flex: 1 },
        }}
      />
      <SearchFilterComp
        clear={clearForm}
        disabled={!manualProductForm?.sales}
        minWidth={0}
        width="100%"
        selectList={customerList}
        size="default"
        autoComplete={{
          customer: {
            label: "Khách hàng",
            limit: 20,
            skip: 0,
            endpoint: manualProductForm?.sales ? `/api/v1/customers` : "",
            params: {
              sales: manualProductForm?.sales,
            },
            state: (e) => handleFillReturnForm("customer", e),
          },
          sx: { flex: 1 },
        }}
      />
      <SearchFilterComp
        clear={clearForm}
        disabled={!manualProductForm?.customer}
        minWidth={0}
        width="100%"
        selectList={productList}
        size="default"
        autoComplete={{
          product: {
            label: "Sản phẩm",
            limit: 20,
            skip: 0,
            endpoint: "/api/v1/products",
            searchField: "name",
            state: (e) => handleFillReturnForm("product", e),
          },
          sx: { flex: 1 },
        }}
      />
      <SearchFilterComp
        clear={clearForm}
        minWidth={0}
        width="100%"
        disabled={!manualProductForm?.product}
        selectList={productModelList}
        size="default"
        autoComplete={{
          productModel: {
            label: "Phân loại sản phẩm",
            limit: 20,
            skip: 0,
            endpoint: manualProductForm?.product ? `/api/v1/products/${manualProductForm?.product}/product-models` : null,
            searchField: "name",
            state: (e) => handleFillReturnForm("productModel", e),
          },
          sx: { flex: 1 },
        }}
      />

      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Số lô</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={manualProductForm?.batch}
          label="Age"
          onChange={(e) => handleFillReturnForm("batch", e.target.value)}
        >
          {Array.isArray(batch?.data) ? (
            batch?.data?.map((v) => {
              return (
                <MenuItem
                  key={v?._id}
                  value={v?.batch?._id}
                >
                  {v?.batch?.code}
                </MenuItem>
              );
            })
          ) : (
            <MenuItem value={null}>Không có data được tìm thấy</MenuItem>
          )}
        </Select>
      </FormControl>

      <TextField
        disabled={!manualProductForm?.batch}
        label="Số lượng"
        fullWidth
        value={manualProductForm?.qty || ""}
        onChange={(e) => handleFillReturnForm("qty", Number(e.target.value))}
      />

      <Button
        disabled={!manualProductForm?.qty}
        onClick={onAddProduct}
        fullWidth
        variant="contained"
      >
        Thêm sản phẩm
      </Button>
    </Box>
  );
}
